import { getListOfUsers } from "../types/account_users_types";

const initState = {
  data: [],
  Count: 0,
  loading: false,
  error: null,
  cellLoading: null,
};

export default function accountUsersReducer(state = initState, action = {}) {
  switch (action.type) {
    case getListOfUsers.GET_LIST_OF_USERS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case getListOfUsers.GET_LIST_OF_USERS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.data,
        Count: action.payload.Count,
        error: null,
      };
    case getListOfUsers.GET_LIST_OF_USERS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
}
